@if (data.title) {
  <h1 mat-dialog-title>{{ data.title }}</h1>
}

<mat-dialog-content>
  @if (data.description) {
    <p>{{ data.description }}</p>
  }

  <mat-form-field appearance="outline">
    <mat-label>{{ data.label }}</mat-label>
    <input
      matInput
      (keydown.enter)="submit()"
      [ngModel]="value"
      (ngModelChange)="value = $event"
      [type]="data.type ?? 'text'"
      [placeholder]="data.placeholder ?? ''"
    />
  </mat-form-field>

  @if (data.checkbox_label) {
    <mat-checkbox [(ngModel)]="checkboxChecked">{{ data.checkbox_label }}</mat-checkbox>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-flat-button color="accent" (click)="submit()">{{ data.close_button_text }}</button>
</mat-dialog-actions>
